// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SellerTemplate_sellerTemplatemain__uBpCA {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 16px;
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  margin: 0 0 12px;
  background: #ffffff;
  transition: box-shadow 0.15s ease;
}
.SellerTemplate_sellerTemplatemain__uBpCA:hover {
  box-shadow: 0 8px 22px rgba(43, 22, 87, 0.08);
}

.SellerTemplate_sellerTemplateDesc__oOkAW {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.SellerTemplate_sellerTemplateDesc__oOkAW p:nth-child(1) {
  font-family: 'Sora', 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #1F2430;
  margin: 0;
}

.SellerTemplate_sellerTemplateDesc_mail__5lwiG {
  display: flex;
  align-items: center;
}

.SellerTemplate_sellerTemplateDesc_mail__5lwiG > p {
  font-size: 12.5px;
  color: #6B7280;
  margin: 0;
  word-break: break-all;
}

.SellerTemplate_sellerTemplateDesc__oOkAW > div > p {
  font-size: 12.5px;
  color: #6B7280;
  margin: 0;
}

.SellerTemplate_sellerTemplateDesc__oOkAW button {
  align-self: flex-start;
  border: none;
  outline: none;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  background: #FDEEDD;
  color: #F7941D;
  cursor: default;
}

.SellerTemplate_success__FIfOh {
  background: #E9F9EF !important;
  color: #16A34A !important;
}
.SellerTemplate_danger__iRm8T {
  background: #FDEDED !important;
  color: #DC2626 !important;
}

.SellerTemplate_sellerTemplateButtons__iskel {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.SellerTemplate_actionRow__qlNwv {
  display: flex;
  align-items: center;
  gap: 6px;
}

.SellerTemplate_iconBtn__Ensv4 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #F5F3FE;
  cursor: pointer;
  transition: background 0.15s ease;
  border: none;
}
.SellerTemplate_iconBtn__Ensv4:hover {
  background: #E7DEFB;
}

.SellerTemplate_loginPill__sMkUO {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  background: #F5F3FE;
  color: #4c2fb3;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  border: none;
  transition: background 0.15s ease;
}
.SellerTemplate_loginPill__sMkUO:hover {
  background: #E7DEFB;
}

.SellerTemplate_viewBtn__1DtE4 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  cursor: pointer;
  white-space: nowrap;
}

/* =========================================================
   Detail modal (check live)
   ========================================================= */
.SellerTemplate_legacyDetailWrap__ye4Bs h2 {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #4c2fb3 !important;
  margin: 16px 0 8px !important;
}
.SellerTemplate_legacyDetailWrap__ye4Bs h2:first-child {
  margin-top: 0 !important;
}
.SellerTemplate_legacyDetailWrap__ye4Bs table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  border: 1px solid #E7E9F1 !important;
  border-radius: 10px !important;
  overflow: hidden !important;
}
.SellerTemplate_legacyDetailWrap__ye4Bs th {
  background: #F5F3FE !important;
  color: #4c2fb3 !important;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-size: 11px !important;
  font-weight: 700 !important;
  border-color: #E7E9F1 !important;
}
.SellerTemplate_legacyDetailWrap__ye4Bs td {
  border-color: #F1F2F6 !important;
  font-size: 12.5px;
  color: #374151;
}

@media screen and (max-width: 375px) {
  .SellerTemplate_sellerTemplateDesc__oOkAW p {
    font-size: 12px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SellerViewTemplate/SellerTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".sellerTemplatemain {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 16px;\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  margin: 0 0 12px;\n  background: #ffffff;\n  transition: box-shadow 0.15s ease;\n}\n.sellerTemplatemain:hover {\n  box-shadow: 0 8px 22px rgba(43, 22, 87, 0.08);\n}\n\n.sellerTemplateDesc {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.sellerTemplateDesc p:nth-child(1) {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #1F2430;\n  margin: 0;\n}\n\n.sellerTemplateDesc_mail {\n  display: flex;\n  align-items: center;\n}\n\n.sellerTemplateDesc_mail > p {\n  font-size: 12.5px;\n  color: #6B7280;\n  margin: 0;\n  word-break: break-all;\n}\n\n.sellerTemplateDesc > div > p {\n  font-size: 12.5px;\n  color: #6B7280;\n  margin: 0;\n}\n\n.sellerTemplateDesc button {\n  align-self: flex-start;\n  border: none;\n  outline: none;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  background: #FDEEDD;\n  color: #F7941D;\n  cursor: default;\n}\n\n.success {\n  background: #E9F9EF !important;\n  color: #16A34A !important;\n}\n.danger {\n  background: #FDEDED !important;\n  color: #DC2626 !important;\n}\n\n.sellerTemplateButtons {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.actionRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.iconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: #F5F3FE;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  border: none;\n}\n.iconBtn:hover {\n  background: #E7DEFB;\n}\n\n.loginPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 20px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  border: none;\n  transition: background 0.15s ease;\n}\n.loginPill:hover {\n  background: #E7DEFB;\n}\n\n.viewBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 6px 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n/* =========================================================\n   Detail modal (check live)\n   ========================================================= */\n.legacyDetailWrap h2 {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  color: #4c2fb3 !important;\n  margin: 16px 0 8px !important;\n}\n.legacyDetailWrap h2:first-child {\n  margin-top: 0 !important;\n}\n.legacyDetailWrap table {\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n  border: 1px solid #E7E9F1 !important;\n  border-radius: 10px !important;\n  overflow: hidden !important;\n}\n.legacyDetailWrap th {\n  background: #F5F3FE !important;\n  color: #4c2fb3 !important;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  border-color: #E7E9F1 !important;\n}\n.legacyDetailWrap td {\n  border-color: #F1F2F6 !important;\n  font-size: 12.5px;\n  color: #374151;\n}\n\n@media screen and (max-width: 375px) {\n  .sellerTemplateDesc p {\n    font-size: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sellerTemplatemain": `SellerTemplate_sellerTemplatemain__uBpCA`,
	"sellerTemplateDesc": `SellerTemplate_sellerTemplateDesc__oOkAW`,
	"sellerTemplateDesc_mail": `SellerTemplate_sellerTemplateDesc_mail__5lwiG`,
	"success": `SellerTemplate_success__FIfOh`,
	"danger": `SellerTemplate_danger__iRm8T`,
	"sellerTemplateButtons": `SellerTemplate_sellerTemplateButtons__iskel`,
	"actionRow": `SellerTemplate_actionRow__qlNwv`,
	"iconBtn": `SellerTemplate_iconBtn__Ensv4`,
	"loginPill": `SellerTemplate_loginPill__sMkUO`,
	"viewBtn": `SellerTemplate_viewBtn__1DtE4`,
	"legacyDetailWrap": `SellerTemplate_legacyDetailWrap__ye4Bs`
};
export default ___CSS_LOADER_EXPORT___;
